module.exports = __webpack_public_path__ + "static/media/sbp-logo-btn-light.b6fb05b9.svg";